import Api from "../../../../../Services/Api";
import {
  contructQueryParam,
  fetchDataAsync,
} from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";

export const dummyDataInventoryOtherItem = [
  {
    id: 1,
    kodeOtherItem: "HCK",
    namaOtherItem: "Scoopy Sporty Chrome",
    category: "BK",
    locator: "Storing Lt.2 A1",
    jumlah: 4,
  },
];

export const initialFilterDataOtherItem = {
  id: null,
  otherItemCode: null,
  otherItemName: null,
  otherCategoryValue: null,
  locatorName: null,
  otherItemBarcode: null,
};

export const initialDataOtherItem = {
  id: null,
  otherItemCode: null,
  otherItemName: null,
  otherItemCategory: null,
  kodeLocator: null,
  jumlah: null,
};

export const initialSearchOtherItem = {
  otherItemName: null,
};

export const tableConfigOtherItem = [
  {
    name: "otherItemCode",
    label: "Kode Barang Lain",
    options: {
      sort: true,
    },
  },
  {
    name: "otherItemName",
    label: "Nama Barang Lain",
    options: {
      sort: false,
    },
  },
  {
    name: "otherCategoryValue",
    label: "Kategori",
    options: {
      sort: false,
    },
  },
  {
    name: "locatorName",
    label: "Locator",
    options: {
      sort: false,
    },
  },
  {
    name: "qty",
    label: "Jumlah",
    options: {
      sort: false,
    },
  },
];

export const pageConfigOtherItem = {
  home: {
    pageTitle: "Barang Lain",
    tableConfig: tableConfigOtherItem,
    searchGrid: { name: "nameotheritem", label: "Nama Barang Lain" },
  },
  filter: [
    {
      type: "SimpleDDL",
      box: "search",
      name: "otherItemCode",
      label: "Kode Barang Lain",
    },
    {
      type: "SimpleInput",
      name: "otherItemName",
      label: "Nama Barang Lain",
      readOnly: true,
    },
    {
      type: "SimpleDDL",
      box: "search",
      name: "otherCategoryValue",
      label: "Kategori",
    },
    {
      type: "SimpleDDL",
      id: "select_options_filter_lcoator",
      box: "search",
      name: "locatorName",
      label: "Locator",
    },
    {
      type: "SimpleInput",
      id: "input_text_qr_code",
      name: "otherItemBarcode",
      label: "QR Code",
    },
  ],
  detail: {
    pageTitle: "Detail Inventory Barang Lain",
    tableConfig: [
      {
        name: "qrCode",
        label: "QR Code",
        options: {
          sort: true,
        },
      },
    ],
    firstGrid: [
      { name: "otherItemCode", label: "Kode Barang Lain" },
      { name: "otherItemName", label: "Nama Barang Lain" },
    ],
    secondGrid: [
      { name: "otherCategoryValue", label: "Kategori" },
      { name: "locatorName", label: "Locator" },
    ],
    detailHistory: {
      pageTitle: "Riwayat Mutasi OtherItem",
      firstGrid: [
        { name: "otherItemCode", label: "Kode Barang Lain" },
        { name: "otherItemName", label: "Nama Barang Lain" },
      ],
    },
  },
  stock: {
    pageTitle: "Kartu Stock Barang Lain",
    firstGrid: [
      { name: "otherItemCode", label: "Kode Barang Lain" },
      { name: "otherItemName", label: "Nama Barang Lain" },
    ],
    secondGrid: [
      { name: "otherCategoryValue", label: "Kategori" },
      { name: "locatorName", label: "Locator" },
    ],
    stockInfo: {
      pageTitle: "Detail Stock Info (Dengan QR)",
    },
  },
};

const constructInventoryOtherItemBody = (body) => ({
  listKodeCabang: body?.paramFilters?.kodeCabang ?? [],
  otherItemCode: body?.paramFilters?.otherItemCode ?? null,
  otherItemBarcode: body?.paramFilters?.otherItemBarcode ?? null,
  otherItemCategory: body?.paramFilters?.otherCategoryValue ?? null,
  kodeLocator: body?.paramFilters?.locatorName ?? null,
  otherItemName: body?.paramFilters?.nameotheritem ?? null,

  limit: body?.limit ?? 5,
  page: body?.page ?? 1,
});

export const fetchDataInventoryOtherItem = async (setState, body, setError) => {
  const requestBody = constructInventoryOtherItemBody(body);
  try {
    const response = await Api.create(
      "NAGAMAS_TRANSACTION"
    ).getAllInventoryOtherItemByParam(requestBody);

    setState((prevState) => ({
      ...prevState,
      dataTable: response.data.data,
      pagination: {
        ...prevState.pagination,
        count: response.data.totalData,
      },
    }));
  } catch (err) {
    console.error(err);
    setError && setError(err);
  }
};

export const fetchDataMasterOtherItem = async (setState) => {
  try {
    let response = await Api.create(
      "NAGAMAS_MASTER_DATA"
    ).getAllOtherItemPagingByParam({
      paramFilters: {},
      limit: null,
      page: null,
    });

    if (response.ok) {
      setState((prevState) => ({
        ...prevState,
        dataOtherItemDDL: response.data.data,
      }));
    }
  } catch (error) {
    console.log("errors: ", error);
  }
};

export const fetchDataDetailInventoryOtherItem = async (
  setState,
  body,
  setError
) => {
  let requestBody = null;
  if (body && Object.keys(body).length > 0) {
    requestBody = {
      otherItemCode: body.otherItemCode,
      kodeLocator: body.kodeLocator,
      kodeCabang: body.kodeCabang,
    };
  }

  let response = await fetchDataAsync({
    asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailInventoryOtherItem,
    menuName: "Detail Inventory Other Item",
    setError,
    args:
      requestBody && Object.keys(requestBody).length > 0
        ? requestBody
        : {
            paramFilters: {},
            page: 1,
            limit: 5,
          },
  });

  if (response.ok && response.data.status === HttpStatus.SUCCESS) {
    const mapped = response.data.data.map((item) => ({
      qrCode: item.barcode,
    }));

    setState((prevState) => ({
      ...prevState,
      dataTable: mapped,
      rawDataTable: mapped,
      pagination:{
          ...prevState.pagination,
          count: response.data.data.length
      }
    }));
  }
};

export const fetchDataDetailHistoryInventoryOtherItem = async (
  setState,
  body,
  setError
) => {
  let requestBody = null;
  if (body && Object.keys(body).length > 0) {
    requestBody = {
      barcode: body.qrCode,
    };
  }

  let response = await fetchDataAsync({
    asyncFn: Api.create("NAGAMAS_TRANSACTION")
      .getDetailHistoryInventoryOtherItem,
    menuName: "Detail History Inventory Other Item",
    setError,
    args: contructQueryParam(requestBody),
  });

  if (response.ok && response.data.status === "S") {
    const list = response.data.data?.listHistory ?? [];

    const mappedData = list.map((item) => {
      const [date, time] = item.trxTime.split(" ");

      return {
        date,
        hour: time.substring(0, 5),
        trxCode: item.historyFixing || item.trxType,
        trxId: item.trxId,
        kodeLocator: item.kodeLocator,
        kodeCabang: item.kodeCabang,
      };
    });

    setState((prev) => ({
      ...prev,
      dataTable: mappedData,
      pagination:{
          ...prev.pagination,
          count: response.data.data.length
      }
    }));
  }
};

export const fetchCardStockOtherItem = async (
  setState,
  body,
  setError,
  selectedData
) => {
  const fixedBody = {
    startDate: body.startDate,
    endDate: body.endDate,
    otherItemCode: selectedData.otherItemCode,
    kodeLocator: selectedData.kodeLocator,
    kodeCabang: body.kodeCabang,
  };

  let res = await fetchDataAsync({
    asyncFn: Api.create("NAGAMAS_TRANSACTION").getOtherItemStockCard,
    menuName: "Kartu Stock Gift",
    setError,
    args: fixedBody,
  });

  if (res.ok && res.data.status === HttpStatus.SUCCESS) {
    setState((prevState) => ({
      ...prevState,
      dataTable: res.data.data,
      pagination:{
          ...prevState.pagination,
          count: res.data.data.length
      }
    }));
  }
};

// export const fetchCardStockDetailOtherItem = async (
//   setState,
//   body,
//   setError,
//   selectedParentData
// ) => {
//   const requestBody = {
//     stockDetailDate: body.stockDate,
//     otherItemCode: selectedParentData.otherItemCode,
//     kodeCabang: body.kodeCabang,
//     kodeLocator: body.kodeLocator,
//     trxType: body.transactionType,
//   };

//   const apiFunction = Api.create(
//     "NAGAMAS_TRANSACTION"
//   ).getOtherItemStockCardDetail;
//   const menuName = "Kartu Stock Other Item"; 

//   let res = await fetchDataAsync({
//     asyncFn: apiFunction,
//     menuName,
//     setError,
//     args: requestBody,
//   });

//   if (res.ok && res.data.status === HttpStatus.SUCCESS) {
//     setState((prev) => ({
//       ...prev,
//       dataTable: res.data.data,
//     }));
//   }
// };

export const fetchCardStockDetailOtherItem = async (setState, body, setError, selectedParentData ) => {
  const requestBody = {
    stockDetailDate: body.stockDate,
    otherItemCode: selectedParentData.otherItemCode,
    kodeCabang: body.kodeCabang,
    kodeLocator: body.kodeLocator,
    trxType: body.transactionType,
  };

  const apiFunction = selectedParentData.barcode
    ? Api.create("NAGAMAS_TRANSACTION").getOtherItemStockCardDetailBarcode
    : Api.create("NAGAMAS_TRANSACTION").getOtherItemStockCardDetailNonBarcode;

  const menuName = selectedParentData.barcode
    ? "Kartu Stock Barang Lain Dengan QR"
    : "Kartu Stock Barang Lain Tanpa QR";

  let res = await fetchDataAsync({
    asyncFn: apiFunction,
    menuName,
    setError,
    args: requestBody,
  });
  console.log(res);

  if (res.ok && res.data.status === HttpStatus.SUCCESS) {
    setState((prevState) => ({
      ...prevState,
      dataTable: res.data.data,
      pagination:{
          ...prevState.pagination,
          count: res.data.data.length
      }
    }));
  }
};
